<template>
    <div class="animated fadeIn">
        <b-container class="w-75 mx-auto py-2" v-if="entity.uuid">
            <b-card class="w-100" md="12">

                <div class="progress-group">
                    <div class="progress-group-header">
                        <i class="cui-user progress-group-icon"></i>
                        <div>Datos Bancarios</div>
                        <div class="ml-auto font-weight-bold">Paso 3 de 4</div>
                    </div>
                    <div class="progress-group-bars">
                        <div class="progress progress-xs">
                            <div
                                class="progress-bar bg-warning"
                                role="progressbar"
                                style="width: 75%"
                                aria-valuenow="75"
                                aria-valuemin="0"
                                aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>

                <b-row class="px-4 py-4 mx-0 bg-light">
                    <b-row class="w-100 px-2 pb-3">

                        <b-col md="6">
                            <!-- IBAN !-->
                            <b-form-group
                                :label="labels.iban"
                                label-for="iban"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="iban"
                                    name="iban"
                                    type="text"
                                    placeholder="Cuenta Bancaria"
                                    v-model="entity.iban"
                                    class="w-100"
                                    v-validate="'iban'"
                                    :state="validateState('iban')"
                                    aria-describedby="check_iban">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_iban">
                                    <small>{{ errors.first('iban') }}</small>
                                </div>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <!-- Entidad!-->
                            <b-form-group
                                :label="labels.bankName"
                                label-for="bankName"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <b-form-input
                                    id="bankName"
                                    name="bankName"
                                    type="text"
                                    placeholder="Entidad"
                                    v-model="entity.bankName"
                                    v-validate="'min:3'"
                                    :state="validateState('bankName')"
                                    aria-describedby="check_bankName">
                                </b-form-input>
                                <div class="text-danger text-right" id="check_bankName">
                                    <small>{{ errors.first('bankName') }}</small>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="w-100 px-2 pb-3">
                        <b-col md="6">
                            <!-- Convenio !-->
                            <b-form-group
                                label="<strong>Convenio</strong>"
                                label-for="agreement"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <fee-agreement-selector
                                    v-model="feeAgreement"
                                    id="agreement"
                                    :headquartersId="entity.headquartersId"
                                    :allowEmpty="true"></fee-agreement-selector>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="w-100 px-2 pb-3">
                        <b-col md="4">
                            <!-- Forma de Pago !-->
                            <b-form-group
                                label="<strong>Forma de Pago *</strong>"
                                label-for="paymentMethod"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <payment-method-selector v-model="entity.paymentMethod" @select="checkPaymentMethod"></payment-method-selector>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <!-- Tipo de Cuota !-->
                            <b-form-group
                                label="<strong>Tipo de Cuota *</strong>"
                                label-for="feeTypeId"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <multiselect
                                    name="feeTypeId"
                                    v-model="entity.feeTypeId"
                                    :options="feeTypes.map(type => type.uuid)"
                                    :custom-label="opt => feeTypes.find(x => x.uuid == opt).name"
                                    :multiple="false"
                                    :allowEmpty="false"
                                    placeholder="Seleccione"
                                    selectedLabel=""
                                    selectLabel="+"
                                    deselectLabel="-"
                                    v-if="feeTypes.length > 0">
                                    <template slot="singleLabel" slot-scope="props">
                                        {{ getFeeTypeLabel(props.option) }}
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ getFeeTypeLabel(props.option) }}
                                    </template>
                                </multiselect>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <!-- Importe !-->
                            <b-form-group
                                label="&nbsp"
                                label-for="amount"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <div class="text-left mt-1" id="check_amount">
                                    <input type="checkbox" v-model="entity.exemptFromPayment"/>
                                    Exento de pago
                                </div>
                            </b-form-group>
                            <!-- !-->
                        </b-col>

                    </b-row>

                    <b-row class="w-100 px-2 pb-3">
                        <b-col md="4">
                            <!-- Pagado Hasta !-->
                            <b-form-group
                                label="<strong>Pagado Hasta</strong>"
                                label-for="paidUntil"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <v-date-picker v-model='entityPaidUntilFormatted' :max-date="new Date()" popoverDirection="top">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <b-form-input
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            id="paidUntil"
                                            name="paidUntil"
                                            class="w-100"
                                            v-validate="{required: true, paidUntil: {birthday: entity.birthday}}"
                                            :state="validateState('paidUntil')"
                                            aria-describedby="check_paidUntil" />
                                    </template>
                                </v-date-picker>
                                <div class="text-danger text-right" id="check_paidUntil">
                                    <small>{{ errors.first('paidUntil') }}</small>
                                </div>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <!-- Fecha Emisión Recibo !-->
                            <b-form-group
                                label="<strong>Fecha de Emisión de Recibo *</strong>"
                                label-for="receiptIssueDate"
                                :horizontal="false"
                                class="w-100 mb-0">
                                <receipt-issue-date-selector
                                    id="receiptIssueDate"
                                    v-model="entity.receiptIssueDate"></receipt-issue-date-selector>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-row>

                <b-row class="pt-4">
                    <div class="col float-left">
                        <router-link
                            class="btn btn-brand btn-danger btn-lg pull-left"
                            :to="{ path:'/partners/accounts/list'}">
                            Cancelar
                        </router-link>
                        <button
                            type="button"
                            class="btn btn-brand btn-primary btn-lg pull-right"
                            :disabled="!validate()"
                            @click="store">
                            Siguiente
                        </button>
                    </div>
                </b-row>
            </b-card>
        </b-container>
    </div>
</template>

<script>
    import {request} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import PaymentMethodSelector from '@/components/clients/members/PaymentMethodSelector';
    import ReceiptIssueDateSelector from '@/components/clients/members/ReceiptIssueDateSelector';
    import feeAgreementSelector from '@/components/agreements/FeeAgreementSelector';
    import moment from 'moment';

    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: 'addPartners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            PaymentMethodSelector,
            ReceiptIssueDateSelector,
            feeAgreementSelector
        },
        props: ['partner'],
        data: function () {
            return {
                // view
                topmenu: [
                    {name: 'Volver', path: '/admin/agreements/list', brand: 'fa fa-arrow-left'},
                ],
                title: 'Nuevo Socio',
                subtitle: 'Paso 3 de 4',
                entity: {
                    iban: '',
                    bankName: '',
                    agreementId: null,
                    paymentMethod: '',
                    feeTypeId: null,
                    exemptFromPayment: false,
                    paidUntil: null,
                    receiptIssueDate: null,
                    headquartersId: null
                },
                feeAgreement: {
                    uuid: this.partner.agreementId
                },
                // dependencies
                feeTypes: [],
                today: null,
                checking: false,
                // requirements
                strings: ['paymentMethod', 'feeTypeId', 'receiptIssueDate'],
                arrays: [],
                labels: {
                    iban: '<strong>IBAN</strong>',
                    bankName: '<strong>Entidad</strong>'
                }
            }
        },
        computed: {
            entityPaidUntilFormatted: {
                get() {
                    return this.entity.paidUntil && new Date(this.entity.paidUntil)
                },
                set(newValue) {
                    this.entity.paidUntil = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            },
        },
        mounted() {
            this.checkPaymentMethod();
            this.requests('fee/types', 'get', 200, 'feeTypes');
            this.entity = Object.assign({}, this.entity, this.partner);
            if (this.entity.paidUntil) {
                this.entity.paidUntil = moment(this.entity.paidUntil).format('YYYY-MM-DD');
            }
            this.today = new Date();
            const day = moment(this.partner.registeredAt).date();
            if (day >=1 && day <=24) {
                this.entity.receiptIssueDate = this.getMonthDay(this.partner.registeredAt, 1);
            } else if (day >=25 && day <=31) {
                this.entity.receiptIssueDate = this.getMonthDay(this.partner.registeredAt, 2);
            }
        },
        methods: {
            checkPaymentMethod() {
                if (this.entity.paymentMethod == 'BANK') {
                    this.strings.push('iban', 'bankName');
                    this.labels.iban = '<strong>IBAN *</strong>';
                    this.labels.bankName = '<strong>Entidad *</strong>';
                }
                else {
                    var i;
                    i = this.strings.indexOf('iban');
                    this.strings.splice(i, 1);
                    i = this.strings.indexOf('bankName');
                    this.strings.splice(i, 1);
                    this.labels.iban = '<strong>IBAN</strong>';
                    this.labels.bankName = '<strong>Entidad</strong>';
                }
            },
            getMonthDay(date, amountMonth) {
                const lastDateMonth = moment(date).add(amountMonth, 'M').endOf("month").format('YYYY-MM-DD');
                const month = moment(lastDateMonth, 'YYYY-MM-DD').month();
                return month + 1;
            },
            getFeeTypeLabel(feeTypeUuid) {
                let feeType = this.feeTypes.find(feeType => feeType.uuid === feeTypeUuid);
                return `${feeType.name} - ${feeType.amount}€`;
            },
            store() {
                let self = this;
                try {
                    this.$_loadingMixin_showLoading();
                    request('/members/' + this.partner.uuid + '/steps/3', 'post', 200, this.entity).then(x => {
                        self.setPartner(x);
                        self.$_loadingMixin_hideLoading();
                    });
                } catch (error) {
                    console.log(error, "<--");
                    self.$_loadingMixin_hideLoading();
                }
            },
            async requests(path, method, okCode, entity) {
                this.$_loadingMixin_showLoading();
                this[entity] = await request(path, method, okCode);
                this.$_loadingMixin_hideLoading();
            },
            validate() {
                if (this.strings.filter(string => !this.entity[string]).length > 0) {
                    return false;
                } else if (this.arrays.filter(array => this.entity[array].length == 0).length > 0) {
                    return false;
                } else if (this.errors.items.length > 0) {
                    return false;
                } else {
                    return true;
                }
            },
            setPartner(entity) {
                this.$emit('sendPartner', entity);
            }
        },
        watch: {
            'feeAgreement.uuid': function () {
                this.entity.agreementId = this.feeAgreement.uuid
                    ? this.feeAgreement.uuid
                    : null;
            }
        }
    }
</script>
